import '../css/tailwind.css';
import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';

Alpine.plugin(intersect);
window.Alpine = Alpine;

Alpine.store('projectFilter', {
  category: 'all',
});

Alpine.start();
